<script>
import WorkOrderCard from "@/components/WorkOrderCard";

export default {
  components: {
    WorkOrderCard,
  },
  props: {
    packing: {
      type: Object,
      required: true,
    },
  },
  methods: {
    gotoPacking() {
      this.$router.push({
        name: "packingProducts",
        params: { packingId: this.packing.idPublic },
      });
    },
  },
};
</script>

<template>
  <div class="card m-0 h-100">
    <div class="card-body">
      <div
        class="card-title packing-title"
        role="button"
        @click="gotoPacking"
      >
        {{ packing.name }}
      </div>
      <div
        class="packing-contents"
        style="
          overflow: auto;
          scrollbar-color: #dee0e3 transparent;
          scrollbar-width: thin;
          display: flex;
          flex-direction: column;
          gap: 1.25rem;
        "
      >
        <WorkOrderCard
          v-for="(workOrder, index) in packing.workOrderPackingInfoResources"
          :key="index"
          :workOrder="workOrder"
          :packingIdPublic="packing.idPublic"
          @open-files="$emit('open-files', $event)"
        />
      </div>
    </div>
  </div>
</template>
<style scoped>
.packing-title {
  cursor: pointer;
  text-decoration: underline;
}
@media (max-width: 450px) {
  .card-title {
    margin: 0.1rem 0.5rem;
  }
  .card-body {
    padding: 0;
  }
  .packing-contents {
    padding: 0;
  }
}
</style>
